<div
  class="track"
  #track
  [style.background]="domSanitizer.bypassSecurityTrustStyle(trackBackground)"
  [attr.data-testid]="'color-picker-slider-track'"
></div>

<div class="thumb" #thumb [attr.data-testid]="'color-picker-slider-thumb'">
  <mat-icon [attr.data-testid]="'color-picker-slider-thumb-icon'"
    >arrow_drop_down</mat-icon
  >
</div>
